import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "fixed z-50",
  "aria-labelledby": "modal-title",
  role: "dialog",
  "aria-modal": "true"
}
const _hoisted_2 = {
  id: "dialog",
  class: "bounce-modal-animation flex min-h-full items-center justify-center p-0 px-4 text-center"
}
const _hoisted_3 = { class: "absolute top-[-80px] right-0 left-0 z-20 flex flex-col items-center justify-center rounded-full" }
const _hoisted_4 = ["color"]
const _hoisted_5 = ["color"]
const _hoisted_6 = { class: "mt-10 flex flex-col items-center text-grey" }
const _hoisted_7 = {
  key: 0,
  class: "flex items-center justify-center text-xs"
}
const _hoisted_8 = { class: "flex justify-center space-x-2" }
const _hoisted_9 = {
  key: 0,
  class: "flex items-center justify-center text-xs"
}
const _hoisted_10 = {
  key: 1,
  class: "flex items-center justify-center text-xs"
}
const _hoisted_11 = {
  key: 1,
  class: "flex items-center justify-center text-xs"
}
const _hoisted_12 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_button_component = _resolveComponent("button-component")!

  return (_openBlock(), _createBlock(_Transition, {
    name: "modal",
    duration: 600
  }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", _hoisted_1, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "fixed top-0 right-0 left-0 bottom-0 bg-gray-400 bg-opacity-75 transition-opacity" }, null, -1)),
        _createElementVNode("div", {
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onClickOutside && _ctx.onClickOutside(...args))),
          class: "fixed top-0 right-0 left-0 bottom-0 z-10 overflow-y-hidden"
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", {
              onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
              class: "relative h-min w-full rounded-lg bg-background p-8 shadow-xl"
            }, [
              _createElementVNode("div", _hoisted_3, [
                (_openBlock(), _createElementBlock("svg", {
                  fill: "white",
                  class: "h-[150px] w-[150px]",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24",
                  color: _ctx.type === 'error' ? '#FF5252' : '#FFD92F',
                  xmlns: "http://www.w3.org/2000/svg"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "1.5",
                    color: _ctx.type === 'error' ? '#FF5252' : '#FFD92F',
                    "fill-rule": "nonzero",
                    d: "M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  }, null, 8, _hoisted_5)
                ], 8, _hoisted_4))
              ]),
              _createElementVNode("div", _hoisted_6, [
                (_ctx.appName)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.appName), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_8, [
                  (_ctx.platformApp)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.platformApp), 1))
                    : _createCommentVNode("", true),
                  (_ctx.appVersion)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.appVersion), 1))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.userData)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.userData.phone_number), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: "whitespace-pre-line font-semibold mt-3",
                  innerHTML: _ctx.errorMessage
                }, null, 8, _hoisted_12),
                _createVNode(_component_button_component, {
                  onClickAction: _cache[0] || (_cache[0] = ($event: any) => (_ctx.visible = false)),
                  "full-width": false,
                  height: "10",
                  class: "mt-5",
                  "input-class": "px-12",
                  rounded: "lg",
                  title: "Прочитал",
                  color: _ctx.type === 'error' ? 'red' : '[#FFD92F]',
                  "text-color": "white"
                }, null, 8, ["color"])
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["absolute bottom-[-10px] left-0 right-0 z-[-1] ml-auto mr-auto h-12 w-11/12 rounded-lg", _ctx.type === 'error' ? 'bg-red' : 'bg-[#FFD92F]'])
              }, null, 2)
            ])
          ])
        ])
      ], 512), [
        [_vShow, _ctx.visible]
      ])
    ]),
    _: 1
  }))
}